import { render } from "./DuplicateQuote.vue?vue&type=template&id=7a4b911f"
import script from "./DuplicateQuote.vue?vue&type=script&lang=js"
export * from "./DuplicateQuote.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__